import {
  Component,
  ViewEncapsulation,
  SimpleChanges,
  OnChanges,
  Input,
  OnInit,
  HostListener,
  Output,
  EventEmitter,
} from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";
import { faChartBar } from "@fortawesome/pro-solid-svg-icons";
import { VSConsensusPageDataService } from "../vsconsensus-page-data.service";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import { AppService } from "src/app/app.service";
import { SetDpParams } from "src/app/store/actions/global-subheader.actions";
import { environment } from "src/environments/environment";
import { VAIconRegistryService, chartBar } from "@va/core-library/icons";
// import { SetSourceMetaGridFilters } from "src/app/store/actions/right-panel-actions";

export interface TreeNodeInterface {
  id?: string;
  key: string | number;
  children: Array<any>;
  name: string;
  expand?: boolean;
  level?: number;
  parent?: any;
  view?: string;
  cut?: string;
  shortname?: string;
  dataLoaded?: boolean;
  isTabRow?: boolean;
  isExpandableRow?: boolean;
  source?: string;
}

@Component({
  selector: "app-vsconsensus-grid",
  templateUrl: "./vsconsensus-grid.component.html",
  styleUrls: ["./vsconsensus-grid.component.scss"],
  host: { class: "vsconsensus-grid-component" },
  encapsulation: ViewEncapsulation.None,
})
export class VSConsensusGridComponent implements OnChanges, OnInit {
  @Input() vsconsensusMeta: any;
  @Input() gridFilters: Dictionary<any>;
  @Output() showClearFilter = new EventEmitter<boolean>();
  faChartBar = faChartBar;
  mapOfExpandData: { [key: string]: boolean } = {};
  listOfData: Array<any>;
  noOfCols: number;
  loading = true;
  gridHeader: Dictionary<any> = {};
  listOfMapData = [];
  periodFireCount = 0;
  paramFireCount = 0;
  gridScrollValue: Dictionary<any> = { x: "0px", y: "0px" };
  showGrid = false;
  highlightBackground = "";
  tabLineCountMapping = {};
  lineItemHeadersExpanded = true;
  mapOfExpandedData: { [key: string]: TreeNodeInterface[] } = {};
  assetsUrl = environment.assetUrl;
  selectedSources = [];
  selectedSourceList = [];
  popOverMapping: any = {};
  isSourceExcluded = {};

  /* Chart variables */
  chartPopupVisible = false;
  chartPopupType = "";
  companyFullName = "";
  chartPopupDataToUse: any = {};
  beginningStateReferrer = "VSConsensus Page";
  feature = "VSCONSENSUS_PAGE";
  /* Chart variables */
  pendingTabsLoaded = true;

  constructor(
    private dataService: VSConsensusPageDataService,
    private store: Store<AppState>,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([chartBar]);
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.gridScrollValue.y = `${event.target.innerHeight - 360}px`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.vsconsensusMeta &&
      !changes.vsconsensusMeta.firstChange &&
      changes.vsconsensusMeta.currentValue !==
        changes.vsconsensusMeta.previousValue
    ) {
      this.loading = true;
      this.pendingTabsLoaded = true;
      this.bindVSConsensusHeader();
      this.bindVSConsensusData();

      this.gridScrollValue = {
        y: `${window.innerHeight - 360}px`, //todo set insisde window resize hook
        x: `${
          changes.vsconsensusMeta.currentValue.periods.length * 270 + 380
        }px`,
      };
      this.showGrid = true;
    }

    if (
      changes.gridFilters &&
      !changes.gridFilters.firstChange &&
      changes.gridFilters.currentValue !== changes.gridFilters.previousValue
    ) {
      this.gridFilters = changes.gridFilters.currentValue;
      this.bindVSConsensusHeader();

      if (this.gridFilters.showYoY) {
        //show yoy is turned on
        //user history is saved in flow when onFilterChange is called
        this.onChangeYoyPercent();
      } else {
        //show yoy is turned off
        //save user history
        //  this.bindVSConsensusData();
        this.saveUserFilters();
      }
    }
  }

  ngOnInit() {
    // this.store
    //   .select(stateGetter("rightPanel", "sourceMeta", "selectedSources"))
    //   .subscribe((selectedSources) => {
    //     this.isSourceExcluded = {};
    //     this.selectedSources = selectedSources || [];
    //     this.selectedSourceList = this.selectedSources.map((source) => {
    //       this.isSourceExcluded[source.name] = source.excluded;
    //       return source.name;
    //     });
    //     const focusedSource = this.selectedSources.find(
    //       (source) => source.focus
    //     );
    //     const currFocus = focusedSource ? focusedSource.name : "";
    //     if (this.selectedSourceList.includes(currFocus)) {
    //       this.selectedSourceList = this.selectedSourceList.filter(
    //         (sname) => sname !== currFocus
    //       );
    //       this.selectedSourceList.push("Consensus");
    //     }
    //   });
  }

  bindVSConsensusHeader() {
    //header level 1
    this.gridHeader.level1 = [
      {
        label: `All numbers in ${this.vsconsensusMeta.currency}${this.vsconsensusMeta.magnitude} unless stated otherwise`,
        rowspan: 2,
        width: this.lineItemHeadersExpanded ? "300px" : "190px",
        borderRightDotted: true,
        nzLeft: "0px",
        align: "left",
      },
      {
        label: "",
        rowspan: 2,
        width: 30,
        borderRight: true,
        nzLeft: this.lineItemHeadersExpanded ? "300px" : "190px",
        align: "center",
      },
    ];

    this.gridHeader.level2 = [];

    for (let i = 0; i < this.vsconsensusMeta.periods.length; i++) {
      this.gridHeader.level1.push({
        label: this.vsconsensusMeta.periods[i],
        colspan: this.gridFilters.showYoY ? 2 : 3,
        width: this.gridFilters.showYoY ? 180 : 270,
        borderRight: true,
      });

      this.gridHeader.level2.push(
        {
          label: this.vsconsensusMeta.broker_shortname,
          width: 90,
          borderRightDotted: true,
          valueHeader: true,
          align: "right",
          popoverKey: `${this.vsconsensusMeta.periods[i]}-preq`,
        },
        {
          label: "Consensus",
          width: 90,
          borderRightDotted: true,
          valueHeader: true,
          align: "right",
          popoverKey: `${this.vsconsensusMeta.periods[i]}-va-actuals`,
        },
        {
          label: "%Diff",
          width: this.gridFilters.showYoY ? 0 : 90,
          borderRight: true,
          valueHeader: true,
          align: "right",
          popoverKey: "",
        },
      );
    }

    this.bindGridScroll();
  }

  bindGridScroll() {
    const colWidth = this.gridFilters.showYoY ? 180 : 270;
    const additional = this.lineItemHeadersExpanded ? 380 : 270;
    if (this.gridScrollValue)
      this.gridScrollValue.x = `${
        this.vsconsensusMeta.periods.length * colWidth + additional
      }px`;
  }

  // get data for yoy% calculation
  onChangeYoyPercent() {
    const expandedTabs = this.listOfMapData.filter((tab) => tab.expand).length;
    if (expandedTabs === 0) {
      //page intial load. no tabs are expanded yet
      //this case is when yoy is applied on default load. from pervious user settings
      //this case is handled in bindRevisionsData() => bindLineItems() => createGridRows()
      return;
    }
    this.loading = true;
    this.periodFireCount = 0;

    for (let i = 0; i < this.listOfMapData.length; i++) {
      if (
        this.gridFilters.cut_expansions.indexOf(this.listOfMapData[i].name) !==
        -1
      ) {
        for (let j = 0; j < this.vsconsensusMeta.periods.length; j++) {
          this.getPgData(
            this.listOfMapData[i].shortname,
            this.vsconsensusMeta.periods[j],
            "yoy%25",
            this.vsconsensusMeta.periods.length * expandedTabs,
          );
        }
      } else {
        this.listOfMapData[i].dataLoaded = false;
        this.listOfMapData.forEach((item) => {
          this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
        });
      }
    }
  }

  // yoyCalculations(rowData) {
  //   let previousPeriod = "";
  //   for (let i = 0; i < this.vsconsensusMeta.periods.length; i++) {
  //     const period = this.vsconsensusMeta.periods[i];
  //     const splitPeriod = period.split("-");
  //     previousPeriod = `${splitPeriod[0]}-${splitPeriod[1] - 1}`;

  //     // initialzing values
  //     rowData[`value-source-yoy-${period}`] = null;
  //     rowData[`value-source-yoy-dpid-${period}`] = null;
  //     rowData[`value-consensus-yoy-${period}`] = null;
  //     rowData[`value-consensus-yoy-dpid-${period}`] = null;

  //     // if (
  //     //   rowData[`value-source-${previousPeriod}`] &&
  //     //   rowData[`value-source-${period}`]
  //     // ) {
  //     //   const previousSourceValue = rowData[`value-source-${previousPeriod}`];
  //     //   const sourceValue = rowData[`value-source-${period}`];
  //     //   let yoySource = null;
  //     //   if (rowData.unit !== "%") {
  //     //     yoySource =
  //     //       ((sourceValue - previousSourceValue) / previousSourceValue) * 100;
  //     //   } else {
  //     //     yoySource = (sourceValue - previousSourceValue) * 100;
  //     //   }
  //     //   rowData[`value-source-yoy-${period}`] = yoySource;
  //     //   rowData[`value-source-yoy-dpid-${period}`] =
  //     //     rowData[`value-source-dpid-${period}`];
  //     // }

  //     // if (
  //     //   rowData[`value-consensus-${previousPeriod}`] &&
  //     //   rowData[`value-consensus-${period}`]
  //     // ) {
  //     //   const previousConsensus = rowData[`value-consensus-${previousPeriod}`];
  //     //   const currentConsensus = rowData[`value-consensus-${period}`];
  //     //   let yoyRevision = null;
  //     //   if (rowData.unit !== "%") {
  //     //     yoyRevision =
  //     //       ((currentConsensus - previousConsensus) / previousConsensus) * 100;
  //     //   } else {
  //     //     yoyRevision = (currentConsensus - previousConsensus) * 100;
  //     //   }
  //     //   rowData[`value-consensus-yoy-${period}`] = yoyRevision;
  //     //   rowData[`value-consensus-yoy-dpid-${period}`] =
  //     //     rowData[`value-consensus-dpid-${period}`];
  //     // }
  //   }
  //   return rowData;
  // }

  // pgYoyCalculations() {
  //   this.listOfMapData
  //     .filter((el) => {
  //       return el.expand === true;
  //     })
  //     .map((tabData) => {
  //       tabData.children.map((rowData) => {
  //         if (!rowData.header) {
  //           return this.yoyCalculations(rowData);
  //         }
  //         return rowData;
  //       });
  //       return tabData;
  //     });

  //   setTimeout(() => {
  //     this.listOfMapData.forEach((item) => {
  //       this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
  //     });
  //     this.loading = false;
  //   }, 50);
  // }

  bindVSConsensusData() {
    this.listOfMapData = this.vsconsensusMeta.tabs;
    this.bindLineitems();
  }

  bindLineitems() {
    const tabsCount = this.vsconsensusMeta.tabs.filter((tab) =>
      this.vsconsensusMeta.filters.cut_expansions.includes(tab.name),
    ).length;
    this.periodFireCount = 0;
    for (
      let tabIndex = 0;
      tabIndex < this.vsconsensusMeta.tabs.length;
      tabIndex++
    ) {
      const tab = this.vsconsensusMeta.tabs[tabIndex];
      if (
        this.vsconsensusMeta.filters.cut_expansions.indexOf(tab.name) !== -1
      ) {
        this.dataService
          .getLineitemsData(
            tab.shortname,
            tab.view,
            this.vsconsensusMeta.ticker,
          )
          .subscribe(
            (response) => {
              const lineitemData = response;
              this.createGridRows(lineitemData, tab.shortname, tabsCount);
            },
            (err) => {
              console.error(err);
            },
          );
      }
    }
  }

  createGridRows(lineitemData: any, tab: string, tabsCount = 1) {
    this.listOfMapData = this.listOfMapData.map((el, i) => {
      const data = Object.assign({}, el);
      data.key = i + 1;
      data.isTabRow = true;
      data.expand =
        this.gridFilters.cut_expansions.indexOf(el.name) !== -1 ? true : false;

      if (tab === el.shortname) {
        data.children = lineitemData.row_dimensions[0].values.map((obj, j) => {
          const l1Data = Object.assign({}, obj);
          l1Data["key"] = `l1-${j}${1}`;
          l1Data["source"] = obj.header ? null : this.vsconsensusMeta.focus;
          l1Data["isExpandableRow"] = obj.header ? false : true;
          l1Data["parameter_unit"] =
            obj.parameter_unit !== undefined ? obj.parameter_unit : "";

          if (!obj.header && this.selectedSourceList.length > 0) {
            l1Data["children"] = this.selectedSourceList.map((source, k) => {
              const l2Data = Object.assign({}, {});
              l2Data["key"] = `l1${j}${1}-${k}${1}`;
              l2Data["source"] = source;
              l2Data["childRow"] = true;
              return l2Data;
            });
          }
          return l1Data;
        });

        // this.periodFireCount = 0;
        if (data.expand === true) {
          // get data only if expanded
          let fireCount = this.vsconsensusMeta.periods.length;
          fireCount = fireCount * tabsCount;
          fireCount = fireCount * (this.gridFilters.showYoY ? 2 : 1);

          for (let i = 0; i < this.vsconsensusMeta.periods.length; i++) {
            if (this.gridFilters.showYoY) {
              this.getPgData(
                tab,
                this.vsconsensusMeta.periods[i],
                "yoy%25",
                fireCount,
              );
            }

            this.getPgData(
              tab,
              this.vsconsensusMeta.periods[i],
              "initial",
              fireCount,
            );
          }
          data.dataLoaded = true;
        }
      }
      return data;
    });
    this.listOfMapData.forEach((item) => {
      this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
    });
  }

  getPgData(tab: string, period: string, load?: string, periodsCount?: number) {
    // let pgGrow = "";
    // if (load !== "yoy%25") {
    //   pgGrow = "Analytics";
    // } else {
    //   pgGrow = "yoy%25";
    // }

    // const growthType =
    //   this.gridFilters.showYoY && this.gridFilters.vsConsensus === "default"
    //     ? "yoy%25"
    //     : pgGrow;

    const growthType = load === "yoy%25" ? "yoy%25" : "Analytics";
    this.dataService
      .getPgData(
        period,
        tab,
        this.vsconsensusMeta.ticker,
        this.vsconsensusMeta.broker_shortname,
        growthType,
      )
      .subscribe((response: any) => {
        this.periodFireCount++;
        const consensusData =
          response.data && response.data.length && response.data[0].data;
        const sourceData =
          response.data && response.data.length && response.data[1].data;
        const period =
          response.data && response.data.length && response.data[0].period;

        const consensusRevDate =
          response.data &&
          response.data.length &&
          response.data[0].revision_date;
        const sourceRevDate =
          response.data &&
          response.data.length &&
          response.data[1].revision_date;

        this.popOverMapping[`${period}-va-actuals`] = consensusRevDate;
        this.popOverMapping[`${period}-preq`] = sourceRevDate;
        this.listOfMapData
          .filter((el) => el.shortname === tab)[0]
          .children.map((data) => {
            //set default data
            if (load !== "yoy%25") {
              data[`value-perDiff-${period}`] = null;
              data[`value-source-dpid-${period}`] = null;
              data[`value-source-${period}`] = null;
              data[`value-consensus-${period}`] = null;
              data[`value-source-dpid-${period}`] = null;
              data["unit"] = null;
              data["precision"] = null;
              const sourceVal = sourceData.filter(function (value) {
                return value.param_id.toString() === data.id.toString();
              })[0];

              const consensusVal = consensusData.filter(function (value) {
                return value.param_id.toString() === data.id.toString();
              })[0];
              data.source = data.header ? "" : this.vsconsensusMeta.focus;

              if (sourceVal) {
                data[`value-source-${period}`] = sourceVal.value;
                data[`value-perDiff-${period}`] = sourceVal.diff;
                data[`value-source-dpid-${period}`] = sourceVal.id;
                data["unit"] = sourceVal.unit;
                data["precision"] = sourceVal.precision;
              }
              if (consensusVal) {
                data[`value-consensus-${period}`] = consensusVal.value;
                data[`value-consensus-dpid-${period}`] = consensusVal.id;
              }
            } else if (load === "yoy%25") {
              const sourceVal = sourceData.filter(function (value) {
                return value.param_id.toString() === data.id.toString();
              })[0];

              const consensusVal = consensusData.filter(function (value) {
                return value.param_id.toString() === data.id.toString();
              })[0];
              data[`value-source-yoy-${period}`] = sourceVal
                ? sourceVal.value
                : null;
              //
              data[`value-source-yoy-dpid-${period}`] = sourceVal
                ? sourceVal.id
                : null;
              data[`value-consensus-yoy-${period}`] = consensusVal
                ? consensusVal.value
                : null;
              data[`value-consensus-yoy-dpid-${period}`] = consensusVal
                ? consensusVal.id
                : null;
            }

            // const sourceVal = sourceData.filter(function(value) {
            //   return value.param_id.toString() === data.id.toString();
            // })[0];
            //
            // const consensusVal = consensusData.filter(function(value) {
            //   return value.param_id.toString() === data.id.toString();
            // })[0];

            data.expand = false;
            data.dataLoaded = false;
            return data;
          });

        if (this.periodFireCount === periodsCount) {
          // after all pg calls done
          setTimeout(() => {
            this.listOfMapData.forEach((item) => {
              this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
            });
            this.loading = false;

            // this.scrollToLastPeriod();
            if (this.pendingTabsLoaded) {
              this.pendingTabsLoaded = false;
              this.bindPendingTabLines();
            }
            this.onFilterChange();
          }, 100);
        }
      });
  }

  bindPendingTabLines() {
    const tabsCount = this.vsconsensusMeta.tabs.filter(
      (tab) => !this.vsconsensusMeta.filters.cut_expansions.includes(tab.name),
    ).length;
    for (
      let tabIndex = 0;
      tabIndex < this.vsconsensusMeta.tabs.length;
      tabIndex++
    ) {
      if (
        this.vsconsensusMeta.filters.cut_expansions.indexOf(
          this.vsconsensusMeta.tabs[tabIndex].name,
        ) === -1
      ) {
        this.dataService
          .getLineitemsData(
            this.vsconsensusMeta.tabs[tabIndex].shortname,
            this.vsconsensusMeta.tabs[0].view,
            this.vsconsensusMeta.ticker,
          )
          .subscribe((response) => {
            const lineitemData = response;
            this.createGridRows(
              lineitemData,
              this.vsconsensusMeta.tabs[tabIndex].shortname,
              tabsCount,
            );
          });
      }
    }
  }

  collapse(
    array: TreeNodeInterface[],
    data: TreeNodeInterface,
    $event: boolean,
    eventIsSynthetic?: boolean, //whether the event is triggered by user action or recusive code below
  ) {
    if (!eventIsSynthetic && (data.isTabRow || data.isExpandableRow)) {
      const extras = { beginning_state_referrer: "VSConsensus Page" };
      let actionSource = "";
      const mainSource = "";
      let expansionCut = "";

      if (data.isTabRow) {
        //Shows that it is a tab expansion
        if (data.expand === true) {
          actionSource = "VSConsensus Tab Line Expand";
        } else {
          actionSource = "VSConsensus Tab Line Collapse";
        }
        extras["tab"] = data.name;
        expansionCut = data.view;
      } else {
        //Shows that it is a source expansion within a tab
        if (data.expand === true) {
          actionSource = "VSConsensus Source Line Expand";
        } else {
          actionSource = "VSConsensus Source Line Collapse";
        }
        extras["source"] = this.vsconsensusMeta.focus;
        extras["source_list"] = this.selectedSourceList;
        expansionCut = data.parent.view;
      }

      this.appService.logUserAction(
        {},
        this.vsconsensusMeta.ticker,
        expansionCut,
        actionSource,
        extras,
        mainSource,
        actionSource,
      );
    }

    if (data.isTabRow) {
      if (
        data.expand &&
        this.gridFilters.cut_expansions.indexOf(data.name) === -1
      ) {
        //add to cut expansions
        this.gridFilters.cut_expansions.push(data.name);
      } else {
        //remove from cut expansions
        this.gridFilters.cut_expansions =
          this.gridFilters.cut_expansions.filter(
            (cutName) => cutName !== data.name,
          );
      }
      this.saveUserFilters();
    }

    if (data.isTabRow) {
      this.listOfMapData
        .filter((listdata) => listdata.shortname === data.shortname)
        .map((obj) => {
          obj.expand = data.expand;
          if (data.expand === true) {
            obj.dataLoaded = true;
          }
          return obj;
        });
    } else if (data.isExpandableRow) {
      this.listOfMapData
        .filter((listdata) => listdata.shortname === data.parent.shortname)[0]
        .children.map((obj) => {
          if (data.id === obj.id) {
            obj.expand = data.expand;
            if (obj.expand) {
              obj.dataLoaded = true;
            }
          }
          return obj;
        });
    }

    /*
    $event = true ---> Expanding the tab row
    $event = false ---> Collapsing the tab row
    */

    if ($event === false) {
      if (data.children) {
        data.children.forEach((d) => {
          const target = array.find((a) => a.key === d.key)!;
          target.expand = false;
          this.collapse(array, target, false, true);
        });
      } else {
        return;
      }
    } else {
      if (!data.dataLoaded && data.expand === true && data.isTabRow) {
        this.loading = true;
        this.periodFireCount = 0;

        for (let i = 0; i < this.vsconsensusMeta.periods.length; i++) {
          let fireCount = this.vsconsensusMeta.periods.length;
          fireCount = fireCount * (this.gridFilters.showYoY ? 2 : 1);
          if (this.gridFilters.showYoY) {
            this.getPgData(
              data.shortname,
              this.vsconsensusMeta.periods[i],
              "yoy%25",
              fireCount,
            );
          }

          this.getPgData(
            data.shortname,
            this.vsconsensusMeta.periods[i],
            "click",
            fireCount,
          );
        }
        // if (this.gridFilters.showYoY === true) {
        //   this.onChangeYoyPercent();
        // }
      } else if (data.dataLoaded && this.gridFilters.showYoY === true) {
        this.onChangeYoyPercent();
      }
    }
  }

  convertTreeToList(root: TreeNodeInterface): TreeNodeInterface[] {
    const stack: TreeNodeInterface[] = [];
    const array: TreeNodeInterface[] = [];
    const hashMap = {};
    stack.push({
      ...root,
      level: 0,
      expand: root.expand ? root.expand : false,
    });

    // if filter is already applied show count of all visible lines
    if (
      Object.keys(this.gridFilters).length > 0 &&
      this.gridFilters.filterLineItem !== undefined &&
      this.gridFilters.filterLineItem.trim().length > 0
    ) {
      this.tabLineCountMapping[root.name] = root.children
        ? root.children.filter(
            (child) => child.hidden === false && child.header === undefined,
          ).length
        : "";
    } else {
      // remove dummy header from count
      this.tabLineCountMapping[root.name] = root.children
        ? root.children.filter((child) => child.header === undefined).length
        : "";
    }

    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({
            ...node.children[i],
            level: node.level! + 1,
            expand: node.children[i].expand ? true : false,
            parent: node,
          });
        }
      }
    }

    return array;
  }

  visitNode(
    node: TreeNodeInterface,
    hashMap: { [key: string]: boolean },
    array: TreeNodeInterface[],
  ): void {
    if (!hashMap[node.key]) {
      hashMap[node.key] = true;
      array.push(node);
    }
  }

  getExpandedColumnHeight(item) {
    return item.isExpandableRow && item.expand
      ? this.selectedSourceList.length * 31
      : 31;
  }

  onFilterChange(param?: Array<string>) {
    this.listOfMapData.map((data) => {
      if (data.children) {
        data.children.map((rowData) => {
          rowData.hidden = false;

          // percent change filter start
          rowData["highlight"] = [];
          if (this.gridFilters.vsConsensus === "default") {
            rowData.hidden = false;
            for (let i = 0; i < this.vsconsensusMeta.periods.length; i++) {
              rowData[`highlight-green-${this.vsconsensusMeta.periods[i]}`] =
                false;
              rowData[`highlight-red-${this.vsconsensusMeta.periods[i]}`] =
                false;
            }
          } else {
            if (rowData.header) {
              rowData.hidden = true;
            } else {
              let filterPass = 0;
              for (let i = 0; i < this.vsconsensusMeta.periods.length; i++) {
                let val = Number(this.gridFilters.vsConsensus);
                val = rowData.unit === "%" ? val * 100 : val;

                let currentVal =
                  rowData[`value-perDiff-${this.vsconsensusMeta.periods[i]}`];
                if (currentVal !== undefined && currentVal !== null) {
                  currentVal =
                    typeof currentVal === "string"
                      ? currentVal.replace(",", "")
                      : currentVal;
                  currentVal = Math.abs(currentVal);

                  if (
                    rowData[
                      `value-perDiff-${this.vsconsensusMeta.periods[i]}`
                    ] >= val
                  ) {
                    rowData[
                      `highlight-green-${this.vsconsensusMeta.periods[i]}`
                    ] = true;
                    rowData[
                      `highlight-red-${this.vsconsensusMeta.periods[i]}`
                    ] = false;
                  } else if (
                    rowData[
                      `value-perDiff-${this.vsconsensusMeta.periods[i]}`
                    ] < -val
                  ) {
                    rowData[
                      `highlight-red-${this.vsconsensusMeta.periods[i]}`
                    ] = true;
                    rowData[
                      `highlight-green-${this.vsconsensusMeta.periods[i]}`
                    ] = false;
                  } else {
                    rowData[
                      `highlight-green-${this.vsconsensusMeta.periods[i]}`
                    ] = false;
                    rowData[
                      `highlight-red-${this.vsconsensusMeta.periods[i]}`
                    ] = false;
                  }
                  if (currentVal >= val) {
                    filterPass++;
                  }
                }
              }

              if (filterPass > 0) {
                rowData.hidden = false;
              } else {
                rowData.hidden = true;
              }
            }
          }
          // percent change filter end

          // lineitem filter code start
          if (rowData.header) {
            rowData.hidden = true;
          }
          if (!rowData.hidden) {
            if (
              rowData.name
                .toLowerCase()
                .indexOf(this.gridFilters.filterLineItem.toLowerCase()) !== -1
            ) {
              rowData.hidden = false;
            } else {
              rowData.hidden = true;
            }
          }
          // lineitem filter code end
          rowData.expand = false;
          return rowData;
        });
      }
      return data;
    });
    this.listOfMapData.forEach((item) => {
      this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
    });

    //save filters
    this.saveUserFilters();

    //Logging
    if (param) {
      if (param.indexOf("percentChange") !== -1) {
        const selected =
          this.gridFilters.vsConsensus === "default"
            ? "All"
            : `${this.gridFilters.vsConsensus}%`;
        const percentChangeExtras = {
          beginning_state_referrer: "VSConsensus Page",
          "Filter type": selected,
        };
        this.appService.logUserAction(
          {},
          this.vsconsensusMeta.ticker,
          "",
          "VSConsensus Percent Filter",
          percentChangeExtras,
          "",
          "VSConsensus Percent Filter Click",
        );
      }
      if (
        param.indexOf("lineitem") !== -1 &&
        this.gridFilters.filterLineItem !== ""
      ) {
        const liTextChangeExtras = {
          beginning_state_referrer: "VSConsensus Page",
          term_entered: this.gridFilters.filterLineItem,
        };
        this.appService.logUserAction(
          {},
          this.vsconsensusMeta.ticker,
          "",
          "VSConsensus line item filter",
          liTextChangeExtras,
          "",
          "VSConsensus Line item filter",
        );
      }
    }

    this.setClearStatus();
  }

  setDPParams(item, period, columnName) {
    this.highlightBackground = "";
    if (columnName !== "value-perDiff") {
      const ticker = this.vsconsensusMeta.ticker;
      const cut =
        item.parent.view !== undefined
          ? item.parent.view
          : item.childRow !== undefined && item.childRow
            ? item.parent.parent.view
            : "";
      const source = ["value-source", "value-source-yoy"].includes(columnName)
        ? this.vsconsensusMeta.broker_shortname
        : item.source || "Consensus";
      const dpId = item[`${columnName}-dpid-${period}`];
      this.highlightBackground = dpId + columnName;
      const growthType = this.gridFilters.showYoY ? "yoy%25" : "Analytics";
      const dpParams = {
        dp: dpId,
        cut: cut,
        ticker: ticker,
        source: source,
        growthType: growthType,
        shouldLog: true,
        historical_focus: "VSConsensus",
        period: period,
        param: item.dapparameterid,
        extras: dpId,
      };

      this.appService.logUserAction(
        {},
        ticker,
        cut,
        "VSConsensus cell click",
        {
          beginning_state_referrer: "VSConsensus Page",
          period: period,
          dpid: dpId,
        },
        source,
        "VSConsensus cell click",
      );

      this.store.dispatch(new SetDpParams(dpParams));
    }
  }

  // onShowMorePeriodsClicked() {
  //   const firstPeriod = this.vsconsensusMeta.periods[0];
  //   const firstPeriodYear = Number(firstPeriod.split("-")[1]);
  //   let periodsToPrepend = [
  //     `FY-${firstPeriodYear - 1}`,
  //     `FY-${firstPeriodYear - 2}`,
  //     `FY-${firstPeriodYear - 3}`
  //   ];

  //   const totalRemaining = firstPeriodYear - this.vsconsensusMeta.start_fiscal;
  //   periodsToPrepend = periodsToPrepend.slice(0, Math.min(totalRemaining, 3));
  //   periodsToPrepend.reverse();
  //   this.addPeriod(periodsToPrepend);
  // }

  // addPeriod(periods) {
  //   //add periods to surprise meta
  //   this.vsconsensusMeta.periods = [
  //     ...periods,
  //     ...this.vsconsensusMeta.periods
  //   ];
  //   const allPeriods = this.vsconsensusMeta.periods;

  //   const colWidth = this.gridFilters.showYoY ? 180 : 270;
  //   const colSpan = this.gridFilters.showYoY ? 2 : 3;

  //   //add column to the level1 headers
  //   const newHeadersL1 = [];
  //   periods.forEach((period) => {
  //     newHeadersL1.unshift({
  //       label: period,
  //       colspan: colSpan,
  //       width: colWidth,
  //       borderRight: true
  //     });
  //   });

  //   this.gridHeader.level1 = [
  //     ...this.gridHeader.level1.slice(0, 3),
  //     ...newHeadersL1,
  //     ...this.gridHeader.level1.slice(3)
  //   ];

  //   //adjust the grid width for newly added columns
  //   this.bindVSConsensusHeader();

  //   //identify expanded tabs
  //   const expandedTabs = this.listOfMapData.filter((tab) => tab.expand);

  //   this.periodFireCount =
  //     allPeriods.length - expandedTabs.length * periods.length;

  //   expandedTabs.forEach((tab) => {
  //     periods.forEach((period) => {
  //       this.loading = true;
  //       this.getPgData(tab.shortname, period);
  //     });
  //   });
  // }

  //Trigger the popup modal for charts
  showChartPopup(rowData: any, chartType: string) {
    this.chartPopupDataToUse = {
      companyFullName: this.vsconsensusMeta.tickerFullName,
      period: this.vsconsensusMeta.periods[0],
      source: rowData.source || "Consensus",
      sourceList: ["Consensus", this.vsconsensusMeta.broker_shortname]
        .concat(this.selectedSourceList)
        .map((source) => {
          return {
            label: source,
            value: source,
            checked: source === rowData.source || source === "Consensus",
          };
        }),
      cut: "NMV",
      forecast: true,
      gAdjust: "implied",
      export: true,
      dapparamId: rowData.childRow
        ? rowData.parent.dapparameterid
        : rowData.dapparameterid,
      ticker: this.vsconsensusMeta.ticker,
      // current_quarter: this.vsconsensusMeta.current_quarter,
      peersList: [],
    };

    this.chartPopupType = chartType;
    this.chartPopupVisible = true;
  }

  //Close the popup modal for charts
  hideChartPopup() {
    this.chartPopupVisible = false;
    this.chartPopupType = "";
  }

  onLineItemColumnCollapse() {
    this.lineItemHeadersExpanded = !this.lineItemHeadersExpanded;
    this.bindVSConsensusHeader();
  }

  saveUserFilters() {
    const jsonData = { filters: { ...this.gridFilters } };
    const ticker = this.vsconsensusMeta.ticker;
    this.dataService.saveUserFilters(jsonData, ticker).subscribe();
  }

  /**
   * scroll to the last period after all pg calls are finished
   */
  scrollToLastPeriod() {
    const container = document.getElementsByClassName("last-period")[0];
    container.scrollIntoView();
  }

  setClearStatus() {
    // same object returns true, not same then false
    // true -> Don't set clear Flag
    // false -> set clear Flag
    const defaultGridFilters = {
      vsConsensus: "default",
      filterLineItem: "",
      cut_expansions: ["Monitor"],
      showYoY: false,
    };
    const diffInFilter = this.appService.compare(
      defaultGridFilters,
      this.gridFilters,
    );

    this.showClearFilter.emit(!diffInFilter);
  }

  getUnit(item, column) {
    let unit = "";
    if (column === "value-perDiff") {
      if (item.unit) {
        unit = item.unit === "%" ? "bps" : "%";
      }
    }
    if (this.gridFilters.showYoY === true) {
      if (item.unit) {
        unit = item.unit === "%" ? "%" : "bps";
      }
    }

    return unit;
  }
}
